const Config = {
    controlsEnabled: true
};

export default Config;